import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class AiQuestionScenario extends BasicScenario {}

